module.exports = __webpack_public_path__ + "img/photo-lifestyle-office.843ae244.jpeg";